const ThirdPartyTypes = {
    Axios: Symbol.for('AxiosInstance'),
    Base64: Symbol.for('Base64'),
    ApplicationInsights: Symbol.for('ApplicationInsights'),
    SessionStorage: Symbol.for('SessionStorage'),
    LocalStorage: Symbol.for('LocalStorage')
};

export default ThirdPartyTypes;